export default __webpack_public_path__ + "locales/ja-JP/JavascriptSdk.json?hash=ab7ec7b4668d7ecf7754ea64d2ac8d5a";